import ApplicationController from '../../support/application_controller'

export default class extends ApplicationController {

  static targets = [
    'subject'
  ]

  // ==== Controllers

  // ==== Actions

  hideSubject() {
    this.subjectTarget.classList.add('u-hide')
  }

  showSubject() {
    this.subjectTarget.classList.remove('u-hide')
  }

  toggleSubject({ currentTarget: { checked } }) {
    this.subjectTarget.classList.toggle('u-hide', !checked)
  }

  // ==== Getters

  // ==== Setters

  // ==== Private

  // ==== Channels

}
